import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Card,
  CardContent,
  Grid,
  InputAdornment,
  Chip,
  Tooltip,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Avatar,
  Badge,
  Switch,
  FormControlLabel,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Search as SearchIcon,
  Add as AddIcon,
  Receipt as TaxIcon,
  Info as InfoIcon,
  Refresh as RefreshIcon,
  Visibility as ViewIcon,
  LocalOffer as TagIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Percent as PercentIcon,
  AccountBalance as GovIcon,
  Calculate as CalculateIcon,
  ShoppingCart as ProductIcon,
  Assignment as ServiceIcon,
  AttachMoney as MoneyIcon,
} from "@mui/icons-material";

const TaxMaster = () => {
  const [taxData, setTaxData] = useState([
    { 
      id: 1, 
      taxCode: "TAX001",
      taxName: "GST 18%", 
      taxType: "GST",
      taxRate: 18,
      applicableOn: "Both",
      description: "Goods and Services Tax at 18%",
      productCount: 125,
      status: "Active",
      isCompound: false,
      isInclusive: false,
      displayOrder: 1,
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 2, 
      taxCode: "TAX002",
      taxName: "GST 12%", 
      taxType: "GST",
      taxRate: 12,
      applicableOn: "Both",
      description: "Goods and Services Tax at 12%",
      productCount: 85,
      status: "Active",
      isCompound: false,
      isInclusive: false,
      displayOrder: 2,
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 3, 
      taxCode: "TAX003",
      taxName: "GST 5%", 
      taxType: "GST",
      taxRate: 5,
      applicableOn: "Both",
      description: "Goods and Services Tax at 5%",
      productCount: 65,
      status: "Active",
      isCompound: false,
      isInclusive: false,
      displayOrder: 3,
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 4, 
      taxCode: "TAX004",
      taxName: "GST 28%", 
      taxType: "GST",
      taxRate: 28,
      applicableOn: "Products",
      description: "Goods and Services Tax at 28% (Luxury items)",
      productCount: 32,
      status: "Active",
      isCompound: false,
      isInclusive: false,
      displayOrder: 4,
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 5, 
      taxCode: "TAX005",
      taxName: "VAT 10%", 
      taxType: "VAT",
      taxRate: 10,
      applicableOn: "Products",
      description: "Value Added Tax at 10%",
      productCount: 48,
      status: "Active",
      isCompound: false,
      isInclusive: false,
      displayOrder: 5,
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 6, 
      taxCode: "TAX006",
      taxName: "Service Tax 15%", 
      taxType: "Service Tax",
      taxRate: 15,
      applicableOn: "Services",
      description: "Tax applicable on services",
      productCount: 22,
      status: "Active",
      isCompound: false,
      isInclusive: false,
      displayOrder: 6,
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 7, 
      taxCode: "TAX007",
      taxName: "Sales Tax 8%", 
      taxType: "Sales Tax",
      taxRate: 8,
      applicableOn: "Products",
      description: "State sales tax",
      productCount: 55,
      status: "Active",
      isCompound: false,
      isInclusive: false,
      displayOrder: 7,
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 8, 
      taxCode: "TAX008",
      taxName: "Cess 2%", 
      taxType: "Cess",
      taxRate: 2,
      applicableOn: "Both",
      description: "Additional cess on certain items",
      productCount: 18,
      status: "Active",
      isCompound: true,
      isInclusive: false,
      displayOrder: 8,
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 9, 
      taxCode: "TAX009",
      taxName: "GST 0% (Exempt)", 
      taxType: "GST",
      taxRate: 0,
      applicableOn: "Both",
      description: "Tax exempt items",
      productCount: 42,
      status: "Active",
      isCompound: false,
      isInclusive: false,
      displayOrder: 9,
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 10, 
      taxCode: "TAX010",
      taxName: "Import Duty 25%", 
      taxType: "Custom Duty",
      taxRate: 25,
      applicableOn: "Products",
      description: "Customs duty on imported goods",
      productCount: 0,
      status: "Inactive",
      isCompound: false,
      isInclusive: false,
      displayOrder: 10,
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
  ]);

  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [typeFilter, setTypeFilter] = useState("all");
  const [applicableFilter, setApplicableFilter] = useState("all");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [successMessage, setSuccessMessage] = useState("");
  const [errors, setErrors] = useState({});

  // Modal state
  const [openModal, setOpenModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [editingTax, setEditingTax] = useState(null);
  const [viewingTax, setViewingTax] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [newTax, setNewTax] = useState({
    taxCode: "",
    taxName: "",
    taxType: "GST",
    taxRate: 0,
    applicableOn: "Both",
    description: "",
    status: "Active",
    isCompound: false,
    isInclusive: false,
    displayOrder: 1,
  });

  // Get unique tax types for filter
  const taxTypes = [...new Set(taxData.map(t => t.taxType))];

  // Helper functions
  const getFilteredTaxes = () => {
    return taxData.filter((tax) => {
      const matchesSearch = Object.values(tax).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      );
      const matchesStatus = statusFilter === "all" || tax.status === statusFilter;
      const matchesType = typeFilter === "all" || tax.taxType === typeFilter;
      const matchesApplicable = applicableFilter === "all" || tax.applicableOn === applicableFilter;
      return matchesSearch && matchesStatus && matchesType && matchesApplicable;
    });
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case 'Active':
        return { backgroundColor: '#e8f5e9', color: '#2e7d32' };
      case 'Inactive':
        return { backgroundColor: '#ffebee', color: '#d32f2f' };
      default:
        return { backgroundColor: '#f5f5f5', color: '#666' };
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'GST': return 'primary';
      case 'VAT': return 'secondary';
      case 'Sales Tax': return 'success';
      case 'Service Tax': return 'info';
      case 'Cess': return 'warning';
      case 'Custom Duty': return 'error';
      default: return 'default';
    }
  };

  const getApplicableColor = (applicable) => {
    switch (applicable) {
      case 'Products': return 'primary';
      case 'Services': return 'secondary';
      case 'Both': return 'success';
      default: return 'default';
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!newTax.taxName.trim()) newErrors.taxName = 'Tax name is required';
    if (!newTax.taxType.trim()) newErrors.taxType = 'Tax type is required';
    if (newTax.taxRate === undefined || newTax.taxRate < 0 || newTax.taxRate > 100) {
      newErrors.taxRate = 'Tax rate must be between 0 and 100';
    }
    if (!newTax.displayOrder || newTax.displayOrder <= 0) {
      newErrors.displayOrder = 'Display order must be greater than 0';
    }
    return newErrors;
  };

  // Handlers
  const handleEdit = (tax) => {
    setEditingTax(tax);
    setNewTax({ ...tax });
    setOpenModal(true);
  };

  const handleView = (tax) => {
    setViewingTax(tax);
    setOpenViewModal(true);
  };

  const handleDelete = (id) => {
    const taxToDelete = taxData.find(t => t.id === id);
    
    if (taxToDelete.productCount > 0) {
      alert(`Cannot delete tax with ${taxToDelete.productCount} products. Please reassign or delete products first.`);
      return;
    }

    if (window.confirm("Are you sure you want to delete this tax?")) {
      setTaxData(taxData.filter((tax) => tax.id !== id));
      setSuccessMessage("Tax deleted successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Search and filter handlers
  const handleSearch = () => {
    setPage(0);
    setSuccessMessage(`Search completed. Found ${getFilteredTaxes().length} taxes.`);
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const handleReset = () => {
    setSearchQuery("");
    setStatusFilter("all");
    setTypeFilter("all");
    setApplicableFilter("all");
    setPage(0);
    setErrors({});
    setSuccessMessage("");
  };

  const handleOpenModal = () => {
    setEditingTax(null);
    setNewTax({
      taxCode: "",
      taxName: "",
      taxType: "GST",
      taxRate: 0,
      applicableOn: "Both",
      description: "",
      status: "Active",
      isCompound: false,
      isInclusive: false,
      displayOrder: 1,
    });
    setErrors({});
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditingTax(null);
    setErrors({});
  };

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setViewingTax(null);
  };

  const handleInputChange = (e) => {
    const { name, value, checked, type } = e.target;
    setNewTax({ 
      ...newTax, 
      [name]: type === 'checkbox' ? checked : value 
    });
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleAddTax = async () => {
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setIsLoading(true);
    try {
      if (editingTax) {
        // Update existing tax
        setTaxData(taxData.map(tax => 
          tax.id === editingTax.id 
            ? { 
                ...tax, 
                ...newTax,
                taxRate: parseFloat(newTax.taxRate),
                updatedDate: new Date().toISOString().split('T')[0]
              }
            : tax
        ));
        setSuccessMessage("Tax updated successfully!");
      } else {
        // Add new tax
        const newId = taxData.length > 0 ? Math.max(...taxData.map(t => t.id)) + 1 : 1;
        const taxCode = `TAX${String(newId).padStart(3, '0')}`;
        setTaxData([...taxData, { 
          id: newId, 
          ...newTax,
          taxCode: newTax.taxCode || taxCode,
          taxRate: parseFloat(newTax.taxRate),
          productCount: 0,
          createdDate: new Date().toISOString().split('T')[0],
          updatedDate: new Date().toISOString().split('T')[0]
        }]);
        setSuccessMessage("Tax added successfully!");
      }
      handleCloseModal();
    } catch (error) {
      setErrors({ general: "An error occurred. Please try again." });
    } finally {
      setIsLoading(false);
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  const filteredTaxes = getFilteredTaxes();

  // Calculate statistics
  const totalTaxes = taxData.length;
  const activeTaxes = taxData.filter(t => t.status === "Active").length;
  const compoundTaxes = taxData.filter(t => t.isCompound).length;
  const totalProducts = taxData.reduce((sum, tax) => sum + tax.productCount, 0);
  const avgTaxRate = (taxData.reduce((sum, tax) => sum + tax.taxRate, 0) / taxData.filter(t => t.taxRate > 0).length).toFixed(2);

  return (
    <Box sx={{ p: 3 }}>
      {/* Header Section */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Badge badgeContent={totalTaxes} color="primary">
            <TaxIcon sx={{ color: 'primary.main', fontSize: 40 }} />
          </Badge>
          <Box>
            <Typography variant="h4" fontWeight="bold" color="primary">
              Tax Master Management
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Manage tax rates and configurations • {filteredTaxes.length} taxes found
            </Typography>
          </Box>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleOpenModal}
          sx={{
            borderRadius: 2,
            px: 3,
            py: 1,
            fontWeight: 600,
            backgroundColor: 'primary.main',
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
          }}
        >
          Add New Tax
        </Button>
      </Box>

      {/* Success Message */}
      {successMessage && (
        <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }}>
          {successMessage}
        </Alert>
      )}

      {/* Statistics Cards */}
      {/* <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <TaxIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="primary">
                {totalTaxes}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Total Taxes
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <CheckCircleIcon sx={{ fontSize: 40, color: 'success.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="success.main">
                {activeTaxes}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Active Taxes
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <CalculateIcon sx={{ fontSize: 40, color: 'warning.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="warning.main">
                {compoundTaxes}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Compound Taxes
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <PercentIcon sx={{ fontSize: 40, color: 'info.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="info.main">
                {avgTaxRate}%
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Avg Tax Rate
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <ProductIcon sx={{ fontSize: 40, color: 'secondary.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="secondary.main">
                {totalProducts}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Total Products
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid> */}

      {/* Search and Filter Section */}
      <Paper sx={{ p: 3, mb: 3, borderRadius: 2, boxShadow: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="Search Taxes..."
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              label="Filter by Type"
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All Types</option>
              {taxTypes.map((type) => (
                <option key={type} value={type}>{type}</option>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              label="Applicable On"
              value={applicableFilter}
              onChange={(e) => setApplicableFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All</option>
              <option value="Products">Products</option>
              <option value="Services">Services</option>
              <option value="Both">Both</option>
            </TextField>
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              label="Status"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                variant="contained"
                onClick={handleSearch}
                startIcon={<SearchIcon />}
                sx={{ flex: 1 }}
              >
                Search
              </Button>
              <Button
                variant="outlined"
                onClick={handleReset}
                startIcon={<RefreshIcon />}
                sx={{ flex: 1 }}
              >
                Reset
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Table Section */}
      <Paper sx={{ borderRadius: 2, boxShadow: 3, overflow: 'hidden' }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f8f9fa' }}>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>S.No</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Tax Code</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Tax Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Rate (%)</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Applicable On</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Products</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Compound</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Inclusive</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }} align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredTaxes.length > 0 ? (
                filteredTaxes
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((tax, index) => (
                    <TableRow 
                      key={tax.id} 
                      sx={{ 
                        '&:hover': { backgroundColor: '#f5f5f5' },
                        transition: 'background-color 0.2s'
                      }}
                    >
                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <TagIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                          {tax.taxCode}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight="600">
                          {tax.taxName}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={tax.taxType} 
                          size="small" 
                          color={getTypeColor(tax.taxType)}
                          sx={{ fontWeight: 500 }}
                        />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <PercentIcon sx={{ fontSize: 16, color: 'primary.main' }} />
                          <Typography variant="body2" fontWeight="600" color="primary">
                            {tax.taxRate}%
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={tax.applicableOn} 
                          size="small" 
                          color={getApplicableColor(tax.applicableOn)}
                          variant="outlined"
                        />
                      </TableCell>
                      <TableCell>
                        <Typography 
                          sx={{ 
                            fontWeight: 600,
                            color: tax.productCount === 0 ? 'text.secondary' : 'primary.main'
                          }}
                        >
                          {tax.productCount}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {tax.isCompound ? (
                          <CheckCircleIcon sx={{ color: 'success.main', fontSize: 20 }} />
                        ) : (
                          <CancelIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
                        )}
                      </TableCell>
                      <TableCell>
                        {tax.isInclusive ? (
                          <CheckCircleIcon sx={{ color: 'info.main', fontSize: 20 }} />
                        ) : (
                          <CancelIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
                        )}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={tax.status}
                          size="small"
                          sx={{
                            ...getStatusStyle(tax.status),
                            fontWeight: 600,
                            fontSize: '0.75rem'
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                          <Tooltip title="View Details">
                            <IconButton
                              size="small"
                              onClick={() => handleView(tax)}
                              sx={{
                                color: 'info.main',
                                '&:hover': {
                                  backgroundColor: 'info.light',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s'
                              }}
                            >
                              <ViewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit Tax">
                            <IconButton
                              size="small"
                              onClick={() => handleEdit(tax)}
                              sx={{
                                color: 'warning.main',
                                '&:hover': {
                                  backgroundColor: 'warning.light',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s'
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete Tax">
                            <IconButton
                              size="small"
                              onClick={() => handleDelete(tax.id)}
                              sx={{
                                color: 'error.main',
                                '&:hover': {
                                  backgroundColor: 'error.light',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s'
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={11} align="center" sx={{ py: 4 }}>
                    <TaxIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                    <Typography variant="body1" color="text.secondary">
                      No taxes found
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Try adjusting your search criteria or add a new tax.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={filteredTaxes.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
      </Paper>

      {/* Add/Edit Tax Modal */}
      <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          padding: '16px 24px',
        }}>
          <Typography variant="h6" component="div" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <TaxIcon />
            {editingTax ? 'Edit Tax' : 'Add New Tax'}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '24px', mt: 2 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Tax Code"
                name="taxCode"
                value={newTax.taxCode}
                onChange={handleInputChange}
                helperText="Auto-generated if left empty"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <TagIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Tax Name"
                name="taxName"
                value={newTax.taxName}
                onChange={handleInputChange}
                error={!!errors.taxName}
                helperText={errors.taxName}
                placeholder="e.g., GST 18%"
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={!!errors.taxType}>
                <InputLabel>Tax Type *</InputLabel>
                <Select
                  name="taxType"
                  value={newTax.taxType}
                  onChange={handleInputChange}
                  label="Tax Type *"
                >
                  <MenuItem value="GST">GST</MenuItem>
                  <MenuItem value="VAT">VAT</MenuItem>
                  <MenuItem value="Sales Tax">Sales Tax</MenuItem>
                  <MenuItem value="Service Tax">Service Tax</MenuItem>
                  <MenuItem value="Cess">Cess</MenuItem>
                  <MenuItem value="Custom Duty">Custom Duty</MenuItem>
                  <MenuItem value="Excise Duty">Excise Duty</MenuItem>
                </Select>
                {errors.taxType && <Typography variant="caption" color="error">{errors.taxType}</Typography>}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Tax Rate (%)"
                name="taxRate"
                type="number"
                value={newTax.taxRate}
                onChange={handleInputChange}
                error={!!errors.taxRate}
                helperText={errors.taxRate}
                required
                inputProps={{ min: 0, max: 100, step: 0.01 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PercentIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Applicable On</InputLabel>
                <Select
                  name="applicableOn"
                  value={newTax.applicableOn}
                  onChange={handleInputChange}
                  label="Applicable On"
                >
                  <MenuItem value="Products">Products Only</MenuItem>
                  <MenuItem value="Services">Services Only</MenuItem>
                  <MenuItem value="Both">Both Products & Services</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Display Order"
                name="displayOrder"
                type="number"
                value={newTax.displayOrder}
                onChange={handleInputChange}
                error={!!errors.displayOrder}
                helperText={errors.displayOrder}
                required
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  name="status"
                  value={newTax.status}
                  onChange={handleInputChange}
                  label="Status"
                >
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Switch
                    checked={newTax.isCompound}
                    onChange={handleInputChange}
                    name="isCompound"
                    color="warning"
                  />
                }
                label="Compound Tax"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Switch
                    checked={newTax.isInclusive}
                    onChange={handleInputChange}
                    name="isInclusive"
                    color="info"
                  />
                }
                label="Tax Inclusive"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                name="description"
                value={newTax.description}
                onChange={handleInputChange}
                multiline
                rows={3}
                placeholder="Enter tax description..."
              />
            </Grid>
          </Grid>
          {errors.general && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {errors.general}
            </Alert>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          <Button onClick={handleCloseModal} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAddTax}
            disabled={isLoading}
            startIcon={isLoading ? <CircularProgress size={20} /> : <AddIcon />}
            sx={{
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
          >
            {isLoading ? 'Processing...' : (editingTax ? 'Update Tax' : 'Add Tax')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Tax Modal */}
      <Dialog open={openViewModal} onClose={handleCloseViewModal} maxWidth="md" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          padding: '16px 24px',
        }}>
          <Typography variant="h6" component="div" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <InfoIcon />
            Tax Details
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '24px', mt: 2 }}>
          {viewingTax && (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Avatar 
                    sx={{ 
                      width: 80, 
                      height: 80, 
                      margin: '0 auto',
                      backgroundColor: 'primary.main',
                    }}
                  >
                    <TaxIcon sx={{ fontSize: 40 }} />
                  </Avatar>
                  <Typography variant="h5" sx={{ mt: 2, fontWeight: 'bold' }}>
                    {viewingTax.taxName}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {viewingTax.taxCode}
                  </Typography>
                  <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
                    <PercentIcon sx={{ color: 'primary.main' }} />
                    <Typography variant="h6" color="primary" fontWeight="bold">
                      {viewingTax.taxRate}%
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Tax Type</Typography>
                  <Box sx={{ mt: 1 }}>
                    <Chip 
                      label={viewingTax.taxType} 
                      color={getTypeColor(viewingTax.taxType)}
                    />
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Applicable On</Typography>
                  <Box sx={{ mt: 1 }}>
                    <Chip 
                      label={viewingTax.applicableOn} 
                      color={getApplicableColor(viewingTax.applicableOn)}
                    />
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Products Using This Tax</Typography>
                  <Typography variant="body1" fontWeight="bold" color="primary">
                    {viewingTax.productCount} Products
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Display Order</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingTax.displayOrder}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Compound Tax</Typography>
                  <Box sx={{ mt: 1 }}>
                    {viewingTax.isCompound ? (
                      <Chip icon={<CheckCircleIcon />} label="Yes" color="warning" />
                    ) : (
                      <Chip icon={<CancelIcon />} label="No" />
                    )}
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Tax Inclusive</Typography>
                  <Box sx={{ mt: 1 }}>
                    {viewingTax.isInclusive ? (
                      <Chip icon={<CheckCircleIcon />} label="Yes" color="info" />
                    ) : (
                      <Chip icon={<CancelIcon />} label="No" />
                    )}
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Status</Typography>
                  <Box sx={{ mt: 1 }}>
                    <Chip
                      label={viewingTax.status}
                      sx={{
                        ...getStatusStyle(viewingTax.status),
                        fontWeight: 600,
                      }}
                    />
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Description</Typography>
                  <Typography variant="body1" sx={{ mt: 1 }}>
                    {viewingTax.description || 'No description available'}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(144, 19, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Created Date</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingTax.createdDate}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(144, 19, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Last Updated</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingTax.updatedDate}
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          <Button onClick={handleCloseViewModal}>Close</Button>
          {viewingTax && (
            <Button
              variant="contained"
              onClick={() => {
                handleCloseViewModal();
                handleEdit(viewingTax);
              }}
              startIcon={<EditIcon />}
              sx={{
                backgroundColor: 'primary.main',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                },
              }}
            >
              Edit Tax
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TaxMaster;

